import { gql } from '@apollo/client'

const DELETE_SELECTION_ITEM_MUTATION = gql`
  mutation deleteColumnSelection($id: ID!) {
    deleteColumnSelection(id: $id)
  }
`

export default DELETE_SELECTION_ITEM_MUTATION
